module.exports = __webpack_public_path__ + "static/img/kr.e0c2b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/flag/kr.png
// module id = 24yO
// module chunks = 0